/*
 * wb-filter-search.js
 * Koleksiyon sol filtre alanindaki filtre gruplarina, deger listesi icinde
 * arama yapan bir kutu ekler. Liquid sablonlarina dokunmaz, tema
 * guncellemelerinden etkilenmez.
 *
 * Bagimlilik yok. Ella 6.x / 7.x facet markup'i ile calisir:
 *   .sidebarBlock.js-filter[data-type-list] > ... > ul.facets__list > li.facets__item
 */
(function () {
  'use strict';

  /* Arama kutusunun goruntulenecegi minimum deger sayisi. */
  var MIN_ITEMS = window.WB_FILTER_SEARCH_MIN || 8;

  var ROOT_ID = 'main-collection-filters';
  var GROUP_SELECTOR = '.sidebarBlock.js-filter[data-type-list]';
  var LIST_SELECTOR = 'ul.facets__list';
  var ITEM_SELECTOR = '.facets__item';

  /* Grup basligina gore aranan metni saklar; sidebar AJAX ile yeniden
     render edildiginde kullanicinin yazdigi metin kaybolmasin diye. */
  var savedQueries = {};

  var TR_MAP = {
    'ı': 'i', 'İ': 'i', 'ş': 's', 'Ş': 's', 'ğ': 'g', 'Ğ': 'g',
    'ü': 'u', 'Ü': 'u', 'ö': 'o', 'Ö': 'o', 'ç': 'c', 'Ç': 'c',
    'â': 'a', 'Â': 'a', 'î': 'i', 'Î': 'i', 'û': 'u', 'Û': 'u'
  };

  /* Turkce karakterleri sadelestirir: "cocuk" yazinca "Çocuk" eslesir. */
  function normalize(text) {
    return String(text || '')
      .replace(/[ıİşŞğĞüÜöÖçÇâÂîÎûÛ]/g, function (c) { return TR_MAP[c]; })
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function groupName(group) {
    var heading = group.querySelector('.sidebarBlock-heading .facets__text');
    return heading ? heading.textContent.trim() : '';
  }

  /* Deger metnini cikarir. Swatch, rectangle ve duz liste sunumlarinin
     hepsinde farkli markup kullanildigi icin sirayla denenir. */
  function itemText(item) {
    var el = item.querySelector('.facet-checkbox__text-label') ||
             item.querySelector('label .text');
    if (el) return el.textContent;

    var label = item.querySelector('label');
    if (label && label.getAttribute('title')) return label.getAttribute('title');

    var hidden = item.querySelector('.visually-hidden');
    if (hidden) return hidden.textContent;

    if (item.getAttribute('data-value')) return item.getAttribute('data-value');

    if (!label) return item.textContent;

    var clone = label.cloneNode(true);
    var count = clone.querySelector('.count');
    if (count && count.parentNode) count.parentNode.removeChild(count);
    return clone.textContent;
  }

  function items(list) {
    return Array.prototype.slice.call(list.querySelectorAll(ITEM_SELECTOR));
  }

  /* Arama baslamadan onceki "show more" durumunu isaretler; boylece arama
     temizlenince liste kullanicinin biraktigi hale geri doner. */
  function snapshot(list) {
    items(list).forEach(function (item) {
      if (item.classList.contains('d-none')) item.setAttribute('data-wb-collapsed', '');
      else item.removeAttribute('data-wb-collapsed');
    });
  }

  function setEmptyState(group, show) {
    var msg = group.querySelector('.wb-facet-search__empty');
    if (msg) msg.hidden = !show;
  }

  function restore(group, list) {
    items(list).forEach(function (item) {
      item.classList.remove('wb-facet-hidden');
      if (item.hasAttribute('data-wb-collapsed')) item.classList.add('d-none');
    });
    var more = group.querySelector('.show-more--list_tags');
    if (more) more.classList.remove('wb-facet-hidden');
    setEmptyState(group, false);
  }

  function apply(group, list, query) {
    var q = normalize(query);

    if (!q) {
      restore(group, list);
      return;
    }

    var visible = 0;
    items(list).forEach(function (item) {
      if (normalize(itemText(item)).indexOf(q) !== -1) {
        item.classList.remove('wb-facet-hidden');
        item.classList.remove('d-none'); /* show-more ile gizlenmis olsa da goster */
        visible++;
      } else {
        item.classList.add('wb-facet-hidden');
      }
    });

    /* Arama sirasinda "Tumunu goster" butonu anlamsiz. */
    var more = group.querySelector('.show-more--list_tags');
    if (more) more.classList.add('wb-facet-hidden');

    setEmptyState(group, visible === 0);
  }

  function inject(group) {
    if (group.querySelector('.wb-facet-search')) return;
    if (group.hasAttribute('data-type-price')) return;

    var list = group.querySelector(LIST_SELECTOR);
    if (!list || !list.parentNode) return;
    if (items(list).length < MIN_ITEMS) return;

    var name = groupName(group);
    var placeholder = name ? name + ' içinde ara' : 'Filtrelerde ara';
    var id = 'wb-facet-search-' + Math.random().toString(36).slice(2, 8);

    var wrap = document.createElement('div');
    wrap.className = 'wb-facet-search';

    var label = document.createElement('label');
    label.className = 'visually-hidden';
    label.setAttribute('for', id);
    label.textContent = placeholder;

    var input = document.createElement('input');
    input.className = 'wb-facet-search__input';
    input.id = id;
    input.type = 'search';
    input.autocomplete = 'off';
    input.placeholder = placeholder;
    /* name verilmiyor: form gonderilse bile filtre URL'ine parametre eklemez. */

    wrap.appendChild(label);
    wrap.appendChild(input);

    var empty = document.createElement('p');
    empty.className = 'wb-facet-search__empty';
    empty.textContent = 'Eşleşen seçenek yok.';
    empty.hidden = true;

    list.parentNode.insertBefore(wrap, list);
    list.parentNode.insertBefore(empty, list.nextSibling);

    /* Yeniden render sonrasi onceki aramayi geri yukle. */
    var saved = name ? savedQueries[name] : '';
    if (saved) {
      input.value = saved;
      snapshot(list);
      input.setAttribute('data-wb-active', '');
      apply(group, list, saved);
    }
  }

  function handleInput(input) {
    var group = input.closest(GROUP_SELECTOR);
    if (!group) return;
    var list = group.querySelector(LIST_SELECTOR);
    if (!list) return;

    var value = input.value;

    if (value && !input.hasAttribute('data-wb-active')) {
      snapshot(list);
      input.setAttribute('data-wb-active', '');
    } else if (!value) {
      input.removeAttribute('data-wb-active');
    }

    var name = groupName(group);
    if (name) {
      if (value) savedQueries[name] = value;
      else delete savedQueries[name];
    }

    apply(group, list, value);
  }

  document.addEventListener('input', function (e) {
    var input = e.target && e.target.closest && e.target.closest('.wb-facet-search__input');
    if (input) handleInput(input);
  });

  /* Input form#CollectionFiltersForm icinde: Enter form gondermesin. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target && e.target.classList && e.target.classList.contains('wb-facet-search__input')) {
      e.preventDefault();
    }
  });

  function init() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll(GROUP_SELECTOR), inject);
  }

  /* Sidebar her filtre degisiminde Section Rendering ile yeniden yaziliyor;
     childList degisimlerini izleyip yeniden enjekte ediyoruz. */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scheduled = false;
      init();
    }, 0);
  }

  function boot() {
    init();
    var root = document.getElementById(ROOT_ID);
    var target = (root && root.parentElement) || document.body;
    if (!window.MutationObserver) return;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
